import { render } from "./SmsSubscriptions.vue?vue&type=template&id=33db0da4"
import script from "./SmsSubscriptions.vue?vue&type=script&lang=js"
export * from "./SmsSubscriptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__